// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 共通ボタンデザイン */
.PostSettings_button__wcVzE {
  background: #1976d2;
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 6px 18px;
  font-size: 1em;
  font-weight: bold;
  cursor: pointer;
  transition: background 0.2s;
}
.PostSettings_button__wcVzE:hover {
  background: #1565c0;
}
.PostSettings_bulkDeleteButton__h9a-H {
  background: #e53935;
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 6px 18px;
  font-size: 1em;
  font-weight: bold;
  cursor: pointer;
  transition: background 0.2s;
  margin-left: 12px;
}
.PostSettings_bulkDeleteButton__h9a-H:disabled {
  background: #f5bdbd;
  color: #fff;
  cursor: not-allowed;
}
.PostSettings_bulkDeleteButton__h9a-H:hover:not(:disabled) {
  background: #b71c1c;
}
/* 削除ボタンデザイン */
.PostSettings_deleteButton__nD7nI {
  background: #e53935;
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 4px 14px;
  font-size: 1em;
  font-weight: bold;
  cursor: pointer;
  transition: background 0.2s;
  margin-left: 8px;
}
.PostSettings_deleteButton__nD7nI:hover {
  background: #b71c1c;
}
.PostSettings_container__L698d {
  max-width: 600px;
  margin: 40px auto;
  padding: 32px 16px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.10);
}
`, "",{"version":3,"sources":["webpack://./src/Page/Settings/PostSettings.module.css"],"names":[],"mappings":"AAAA,cAAc;AACd;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,2BAA2B;AAC7B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,2BAA2B;EAC3B,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA,cAAc;AACd;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,uCAAuC;AACzC","sourcesContent":["/* 共通ボタンデザイン */\r\n.button {\r\n  background: #1976d2;\r\n  color: #fff;\r\n  border: none;\r\n  border-radius: 6px;\r\n  padding: 6px 18px;\r\n  font-size: 1em;\r\n  font-weight: bold;\r\n  cursor: pointer;\r\n  transition: background 0.2s;\r\n}\r\n.button:hover {\r\n  background: #1565c0;\r\n}\r\n.bulkDeleteButton {\r\n  background: #e53935;\r\n  color: #fff;\r\n  border: none;\r\n  border-radius: 6px;\r\n  padding: 6px 18px;\r\n  font-size: 1em;\r\n  font-weight: bold;\r\n  cursor: pointer;\r\n  transition: background 0.2s;\r\n  margin-left: 12px;\r\n}\r\n.bulkDeleteButton:disabled {\r\n  background: #f5bdbd;\r\n  color: #fff;\r\n  cursor: not-allowed;\r\n}\r\n.bulkDeleteButton:hover:not(:disabled) {\r\n  background: #b71c1c;\r\n}\r\n/* 削除ボタンデザイン */\r\n.deleteButton {\r\n  background: #e53935;\r\n  color: #fff;\r\n  border: none;\r\n  border-radius: 6px;\r\n  padding: 4px 14px;\r\n  font-size: 1em;\r\n  font-weight: bold;\r\n  cursor: pointer;\r\n  transition: background 0.2s;\r\n  margin-left: 8px;\r\n}\r\n.deleteButton:hover {\r\n  background: #b71c1c;\r\n}\r\n.container {\r\n  max-width: 600px;\r\n  margin: 40px auto;\r\n  padding: 32px 16px;\r\n  background: #fff;\r\n  border-radius: 12px;\r\n  box-shadow: 0 2px 12px rgba(0,0,0,0.10);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `PostSettings_button__wcVzE`,
	"bulkDeleteButton": `PostSettings_bulkDeleteButton__h9a-H`,
	"deleteButton": `PostSettings_deleteButton__nD7nI`,
	"container": `PostSettings_container__L698d`
};
export default ___CSS_LOADER_EXPORT___;
